const Form064TC = {
    stepName: {
        Statement: "重要事項",
        schoolInfo: "基本資料",
        actingAppointment: "署任安排詳情",
        Certification: "聲明",
        NoteInformation: "備註資料",
        confirmation: "確認",
    },
    header: {
        // note: "註意",
        // labelOne:
        //     "校董會/法團校董會已批准下列署任安排﹝檔號及日期：____________﹞",
        // labelTwo: "有關人員的薪金資料需因此而作出以下的改動",
        labelThree: "有關校長職位的署任，請提供已獲教育局事先批准的詳情",
        labelFour: "上述署任安排源自：",
        labelFive: "署任人員的專責職務",
        labelCertification: "聲明",
    },
    label: {
        // programOption: {
        //     am: "上午",
        //     Pm: "下午",
        //     WholeDay: "全日",
        // },
        committeeOption: {
            SMC: "校董會",
            IMC: "法團校董會",
        },
        actingOption: {
            actingUp:
                "署理較高職級：實職薪金與總薪級表第_______點差額的_______%",
            doublingUp:
                "兼署理較高職級：署任較高職級起薪的23%，或署任較高職級起薪與署任教師實任職位薪金的差額的100%，以數額較大者為準",
        },
        appointmentOption: {
            a: "（a） _______先生／女士（職級為__________）由_____年_____月_____日至____年_____月_____日期間（首尾兩天包括在內）放取病假／產假／進修假期／無薪假期【已獲教育局批准，檔號及日期 ：____________________________】。",
            b: "（b）晉升職缺／因流失而懸空的晉升職位",
            c: "（c）其他理由（請註明） _____________【已獲教育局批准，檔號及日期：_____________】。",
        },
        leaveTypeOption: {
            sick: "病假",
            maternity: "產假",
            study: "進修假期",
            noPay: "無薪假期",
        },
        promotionTypeOption: {
            unfilledPost: "晉升職缺",
            wastagePost: "因流失而懸空的晉升職位",
        },
        salaryPointOption: {
            0: "0",
            1: "1",
            2: "2",
            3: "3",
            4: "4",
            5: "5",
            6: "6",
            7: "7",
            8: "8",
            9: "9",
            10: "10",
            11: "11",
            12: "12",
            13: "13",
            14: "14",
            15: "15",
            16: "16",
            17: "17",
            18: "18",
            19: "19",
            20: "20",
            21: "21",
            22: "22",
            23: "23",
            24: "24",
            25: "25",
            26: "26",
            27: "27",
            28: "28",
            29: "29",
            30: "30",
            31: "31",
            32: "32",
            33: "33",
            34: "34(33A)",
            35: "35(33B)",
            36: "36(33C)",
            37: "37",
            38: "38",
            39: "39",
            40: "40",
            41: "41",
            42: "42",
            43: "43",
            44: "44",
            45: "45(44A)",
            46: "46(44B)",
            47: "47",
            48: "48",
            49: "49",
        },
        titleOption: {
            Mr: "先生",
            Ms: "女士",
        },
        note: "備注",
        statement: "個人資料收集聲明",
        termsConditions: "本人已閱讀「個人資料收集聲明」及完全明白其內容。",
        approverOnly: "本人明白需透過「智方便+」帳戶以辧理申請。",

        schoolName: "學校名稱",
        schoolCode: "學校代碼",
        schoolProgram: "授課時間",
        contactPerson: "聯絡人",
        telNum: "電話號碼",

        head1: "正本：",
        head2: "教育局公積金組",
        head3: "副本：",

        contactAndTelText1: "學校聯絡人",
        contactAndTelText2: "及其電話號碼",
        contactAndTelText3: "(以便教育局處理本表格時作查詢之用)",

        ssdo: "學校所屬的教育局區域教育服務處﹝經辦人：高級學校發展主任",
        ssdo2: "﹞",
        SSDO: "高級學校發展主任",
        head4: "第二副本：",
        head5: "學校存檔",

        committee: "校董會",
        committeeText1: "*",
        committeeText2: "已批准下列署任安排﹝檔號",
        committeeText3: "及日期：",
        committeeText4: "﹞",
        committeeText5: "，而有關人員的薪金資料需因此而作出以下的改動：",

        referenceNum: "檔號",
        approvalDate: "日期",
        englishName: "教師英文姓名",
        chineseName: "教師中文姓名",
        HKICNo: "香港身份證號碼",
        SRN: "員工檔號",
        rank: "實任職級",
        appointRank: "署任職級",
        rankschoolHead: "校長",
        schoolHeadTrue: "是",
        schoolHeadFalse: "否",
        actingPeriod: "署任期",
        actingFrom: "由",
        actingTo: "至",
        actingType: "署任津貼：",
        MPSDiff: "實職薪金與總薪級表差額",
        MPSPoint: "總薪級表：",

        fileRefNo: "檔號",
        fileDate: "文檔日期：",
        approvalFile: "批准信：",

        leaveType: "假期類型：",
        teacherTitle: "稱謂：",
        teacherName: "姓名",
        teacherRank: "職級",
        dateFrom: "由",
        dateTo: "至",

        aLabel1: " (職級為",
        aLabel2: ") 由",
        aLabel3: "至",
        aLabel4: "日期間(首尾兩天包括在內)放取",
        aLabel5: "]。",

        promotionPost: "（b）晉升職缺",
        otherReason: "（c）其他理由（請註明）",
        refNo: "[已獲教育局批准，檔號",
        refDate: "及日期：",
        errorReason: "理由",

        tooltip1: "兼署理較高職級",
        tooltip2:
            "：署任較高職級起薪的23%，或署任較高職級起薪與署任教師實任職位薪金的差額的100%，以數額較大者為準",
        tooltip3: "署理較高職級：",
        tooltip4: "實職薪金與總薪級表第",
        tooltip5: "點差額的",
        confirm: "確認",
    },
    schoolInfoNote: [
        { text: "基本資料" },
        {
            text: "每份表格只適用於一項署任安排。",
        },
        {
            text: "請在填寫前，詳細閱讀個人資料收集聲明。",
        },
        {
            text: "請確保教師知悉所填報的內容，並已閱讀個人資料收集聲明。",
        },
    ],
    salaryInfo: {
        detailSix1:
            "本人承諾，若上述教師的署任期未能符合教育局通告第8/2004號第2段有關發放署任津貼的合資格署任期的各項規定",
        detailSix2:
            "，本人會立即通知教育局公積金組，並將通知副本送交有關的學校發展主任。",
        detailSeven:
            "本人現確認在本表格的基本資料及署任安排詳情內所載的資料均正確無誤。本人承諾有關署任事宜不會令擔任晉升職級的教學／非教學人員的人數超逾已核准的編制。本人並承諾本校會把多付的薪金津貼退還教育局。",
    },
    noteList: [
        {
            text: "在署任安排的生效日期前須完成所需的程序（包括校董會／法團校董會的批准）。在一般情況下，署任安排的生效日期不具追溯效力。",
        },
        {
            text: "資助中學、特殊中學或設有中小學部的特殊學校中學部的全職常額首席學位教師／高級學位教師／學位教師或高級助理教席倘獲推薦及批准署任較高職級的一級校長／二級校長／首席學位教師／高級學位教師或首席助理教席職位並擔任專責職務，而其合資格署任期達30個曆日或以上，可獲發放署任津貼。",
        },
        {
            text: "如署任人員連續休假超過3個工作天影響其合資格署任期的計算及／或涉及署任津貼的扣減（包括休假日及當中的公眾假期和星期日），學校須填寫署任安排﹝署任教師休假/缺勤超逾連續3天以上須調整署任津貼的通知﹞表格通知本局調整署任津貼。",
        },
        {
            text: "在2019／20學年起，在教師職位學位化政策全面推行的情況下，如學校安排由基本職級的學位教師因行政方便而署任短暫缺勤的晉升職級非學位教師，在署任職位達30個曆日或以上的情況下，該學位教師的署任津貼率是署任職位（即相應的晉升職級學位教師職位）起薪與署任教師實任職位薪金的差額的90%。",
        },
        {
            text: "有關詳情可參閱教育局通告第8／2004號及相關的資助則例。",
        },
        {
            text: "在2019／20學年起，在教師職位學位化政策全面推行下，資助學校核准編制内的所有教席均為學位教師職位，換句話説，非學位教師職系内不應該有任何因晉升職缺／懸空晉升職位的署任安排。",
        },
        {
            text: "教育局將會對每份署任申請作出編制預先核查。如有關署任教師於委任日已超逾該校的核准教學人員編制，在釐清該署任安排是否符合編制人數之前，該薪金津貼將不會發放給學校。",
        },
    ],

    errorMsg: {
        numLimit: "請輸入{{limit}}",
        tel: {
            max: "電話號碼必須為最多{{max}}位數",
        },
        actingPeriod: "署任期不能重複",
        actLaterApproval:
            "在署任安排的生效日期前須完成所需的程序(包括校董會／法團校董會的批准)。在一般情況下，署任安排的生效日期不具追溯效力。",
        codeDigit: "此項必須正好是{{digit}}位",
        comparePeriod:
            "署任期限應在休假期限內（病假／ 產假／ 進修假期 ／ 無薪假）。",
        schHeadApproval:
            "校長職位的署任必須事先獲教育局批准。如有查詢，請聯絡有關學校發展主任。",
    },
};

export default Form064TC;
